import React, { useState, useEffect } from 'react';
import { Dialog } from '@mui/material';
import axios from 'axios';
import { toast, Toaster } from 'react-hot-toast';
import ProductView from './ProductView';

const ProductViewModal = ({ open, onClose, product }) => {
  const [loading, setLoading] = useState(false);
  const [publishData, setPublishData] = useState(null);

  useEffect(() => {
    if (open && product?.productId) {
      fetchPublishData();
    }
  }, [open, product?.productId]);

  const fetchPublishData = async () => {
    if (!product?.productId) return;
    
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/product-overview-v2/${product.productId}`);
      setPublishData(response.data);
    } catch (error) {
      console.error('Error fetching publish data:', error);
      toast.error('Failed to load product details');
      setPublishData(null);
      // Close modal after a brief delay so user can see the error toast
      setTimeout(() => {
        onClose();
      }, 2000);
    } finally {
      setLoading(false);
    }
  };

  if (!product) return null;

  return (
    <>
      <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
      <Dialog 
        open={open} 
        onClose={onClose} 
        maxWidth="xl" 
        fullWidth
        PaperProps={{
          sx: { 
            maxHeight: '90vh',
            width: '95%',
            maxWidth: '1400px'
          }
        }}
      >
        {open && <ProductView product={publishData} onClose={onClose} />}
      </Dialog>
    </>
  );
};

export default ProductViewModal;
